import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Field, change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import buscarAdesaoPontoPorEmpresa from '../../actions/adesao-pontos/buscarAdesaoPontoPorEmpresa';
import { renderFieldKM, renderFieldNumber, renderField } from '../../util/inputs';
import Titulo from '../comum/Titulo';
import { PERFIL_ADMIN } from '../../security/securityContext';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import limparConfiguracaoPontoEmpresa from '../../actions/adesao-pontos/limparConfiguracaoPontoEmpresa';
import cadastrarConfiguracaoConsumoPontos from '../../actions/adesao-pontos/cadastrarConfiguracaoConsumoPontos';
import cadastrarConfiguracaoPonto from '../../actions/adesao-pontos/cadastrarConfiguracaoPonto';
import { showSuccessMsg } from '../../util/messagesUtil';
import { realParaNumber } from '../../util/numberUtil';

const SectionCard = ({ icon, title, subtitle, children }) => (
    <div className="vx-config-card">
        <div className="vx-config-card-header">
            <i className="material-icons">{icon}</i>
            <div className="vx-config-card-header-text">
                <h6>{title}</h6>
                {subtitle && <small>{subtitle}</small>}
            </div>
        </div>
        <div className="vx-config-card-body">
            {children}
        </div>
    </div>
);

const renderToggle = ({ input, disabled }) => (
    <label className="vx-switch" style={{ cursor: disabled ? 'not-allowed' : 'pointer', flexShrink: 0, opacity: disabled ? 0.5 : 1 }}>
        <input {...input} type="checkbox" disabled={disabled} />
        <span className="vx-switch-slider" />
    </label>
);

export class PainelCadastroConfiguracaoConsumoPonto extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        if (!this.props.empresaSelecionada.id) {
            this.props.history.push('/menu-adesao-pontos-empresa');
        }
        this.props.limparConfiguracaoPontoEmpresa();
        this.props.buscarAdesaoPontoPorEmpresa(this.props.empresaSelecionada.id)
            .then(() => { this.carregarFormulario(); });
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            this.props.limparConfiguracaoPontoEmpresa();
            this.props.buscarAdesaoPontoPorEmpresa(this.props.empresaSelecionada.id)
                .then(() => { this.carregarFormulario(); });
        }
    }

    carregarFormulario() {
        if (this.props.adesaoPontoEmpresa.empresa) {
            const set = (f, v) => this.props.changeFieldValue('formularioCadastrarConfiguracaoConsumoPontos', f, v);
            set('empresa', this.props.adesaoPontoEmpresa.empresa.nome);
            set('peso', this.props.adesaoPontoEmpresa.peso);
            set('ponto', this.props.adesaoPontoEmpresa.quantidadePonto);
            set('habilitadoGeracaoPontos', this.props.adesaoPontoEmpresa.habilitadoGeracaoPontos);
            set('habilitadoConsumoPontos', this.props.adesaoPontoEmpresa.habilitadoConsumoPontos);
            set('pontosReferencia', this.props.adesaoPontoEmpresa.quantidadePontosReferencia);
            set('percentualEquivalente', this.props.adesaoPontoEmpresa.percentualEquivalente);
        }
    }

    naoEhPerfilAdmin() {
        return !validaPerfis([PERFIL_ADMIN]);
    }

    montarParametros(values) {
        return {
            id: this.props.adesaoPontoEmpresa.id,
            empresaId: this.props.adesaoPontoEmpresa.empresa.id,
            peso: values.peso,
            ponto: values.ponto,
            habilitadoGeracaoPontos: values.habilitadoGeracaoPontos,
            habilitadoConsumoPontos: values.habilitadoConsumoPontos,
            quantidadePontosReferencia: values.pontosReferencia,
            percentualEquivalente: values.percentualEquivalente,
        };
    }

    montarParametrosConfiguracaoConsumoPontos(values) {
        return {
            id: this.props.adesaoPontoEmpresa.id,
            empresaId: this.props.adesaoPontoEmpresa.empresa.id,
            quantidadePontosReferencia: values.pontosReferencia,
            percentualEquivalente: values.percentualEquivalente,
        };
    }

    submit(values) {
        if (this.naoEhPerfilAdmin()) {
            this.props.cadastrarConfiguracaoConsumoPontos(
                this.montarParametrosConfiguracaoConsumoPontos(values),
                this.props.adesaoPontoEmpresa.empresa.id
            ).then(() => { showSuccessMsg('A configuração foi salva com sucesso!'); });
        } else {
            this.props.cadastrarConfiguracaoPonto(this.montarParametros(values))
                .then(() => { showSuccessMsg('A configuração foi salva com sucesso!'); });
        }
    }

    calcularPontos() {
        const valorPassagem = realParaNumber(this.props.valorPassagem);
        const quantidadePonto = parseInt(this.props.adesaoPontoEmpresa.quantidadePonto) /
            realParaNumber(this.props.adesaoPontoEmpresa.peso);
        const pontosGanhos = valorPassagem * quantidadePonto;
        const percentualEquivalente = realParaNumber(this.props.percentualEquivalente);
        const pontosReferencia = +this.props.pontosReferencia;
        const percentualDesconto = (pontosGanhos * percentualEquivalente) / pontosReferencia;

        const InfoRow = ({ label, value, destaque }) => (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
                <span style={{ fontSize: 13, color: '#666' }}>{label}</span>
                <span style={{ fontSize: 14, fontWeight: 700, color: destaque || '#333' }}>{value}</span>
            </div>
        );

        return (
            <div style={{ maxWidth: 400 }}>
                <InfoRow label="Valor da Passagem" value={!this.props.valorPassagem ? 'R$ 0,00' : this.props.valorPassagem} />
                <InfoRow label="Pontos por real" value={isNaN(quantidadePonto) ? 0 : quantidadePonto.toFixed(4)} />
                <InfoRow label="Pontos ganhos" value={isNaN(pontosGanhos) ? 0 : pontosGanhos.toFixed(2)} destaque="var(--vx-primary)" />
                <InfoRow label="Percentual de desconto" value={`${isNaN(percentualDesconto) ? 0 : percentualDesconto.toFixed(2)}%`} destaque="#28a745" />
            </div>
        );
    }

    render() {
        const { handleSubmit, invalid, submitting } = this.props;
        const somenteLeitura = this.naoEhPerfilAdmin();

        return (
            <div className="container-padrao">
                <Titulo texto="Configuração de Pontos" urlRetorno="/menu-adesao-pontos-empresa" />

                <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                    <div style={{ maxWidth: 340, marginBottom: 20 }}>
                        <CampoSelecionarEmpresa />
                    </div>
                </Autorizacao>

                {this.props.adesaoPontoEmpresa.id ? (
                    <form onSubmit={handleSubmit(this.submit)} className="vx-config-page">

                        {/* ── Configuração Geral ── */}
                        <SectionCard icon="stars" title="Configuração de Pontos" subtitle="Parâmetros de geração e consumo de pontos da empresa">
                            <div style={{ marginBottom: 16 }}>
                                <Field name="empresa" type="text" component={renderField}
                                    label="Empresa:" css="form-control" readOnly />
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                                <Field name="peso" component={renderFieldKM} label="Peso:"
                                    css="form-control" readOnly={somenteLeitura} />
                                <Field name="ponto" type="text" component={renderFieldNumber}
                                    formatacao='#########'
                                    readOnly={somenteLeitura}
                                    label="Quantidade de Pontos:"
                                    css="form-control" />
                            </div>

                            <div className="vx-toggle-row">
                                <div className="vx-toggle-info">
                                    <div className="vx-toggle-info-title">Geração de Pontos</div>
                                    <div className="vx-toggle-info-desc">Habilita acúmulo de pontos nas compras de passagem</div>
                                </div>
                                <Field name='habilitadoGeracaoPontos' type="checkbox"
                                    component={renderToggle} disabled={somenteLeitura} />
                            </div>

                            <div className="vx-toggle-row">
                                <div className="vx-toggle-info">
                                    <div className="vx-toggle-info-title">Consumo de Pontos</div>
                                    <div className="vx-toggle-info-desc">Habilita o uso de pontos como desconto na compra</div>
                                </div>
                                <Field name='habilitadoConsumoPontos' type="checkbox"
                                    component={renderToggle} disabled={somenteLeitura} />
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginTop: 16 }}>
                                <Field name="pontosReferencia" component={renderFieldNumber}
                                    label="Pontos de Referência:"
                                    css="form-control" readOnly={false} />
                                <Field name="percentualEquivalente" type="text" component={renderFieldKM}
                                    formatacao='#########'
                                    readOnly={false}
                                    label="Percentual Equivalente (%):"
                                    css="form-control" />
                            </div>
                        </SectionCard>

                        {/* ── Simulador ── */}
                        <SectionCard icon="calculate" title="Simulador de Pontos" subtitle="Calcule quantos pontos e desconto uma passagem gera">
                            <div style={{ maxWidth: 280, marginBottom: 16 }}>
                                <Field name="valorPassagem" type="text" component={renderFieldKM}
                                    formatacao='#########'
                                    readOnly={false}
                                    label="Valor da Passagem (R$):"
                                    css="form-control" />
                            </div>
                            {this.calcularPontos()}
                        </SectionCard>

                        {/* ── Save bar ── */}
                        <div className="vx-config-save-bar">
                            <span className="vx-config-save-hint">
                                <i className="material-icons">info_outline</i>
                                {somenteLeitura ? 'Apenas consumo e pontos de referência podem ser alterados' : 'Todos os campos estão disponíveis para edição'}
                            </span>
                            <button type="submit" disabled={invalid || submitting}
                                className="btn btn-laranja vx-config-save-btn">
                                <i className="material-icons">save</i>
                                Salvar Configuração
                            </button>
                        </div>

                    </form>
                ) : (
                    <div className="vx-empty-state">
                        <i className="material-icons">stars</i>
                        <p>Não existe configuração de pontos para a empresa selecionada.</p>
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        adesaoPontoEmpresa: state.adesaoPontoEmpresa,
        pontosReferencia: formValueSelector('formularioCadastrarConfiguracaoConsumoPontos')(state, 'pontosReferencia'),
        percentualEquivalente: formValueSelector('formularioCadastrarConfiguracaoConsumoPontos')(state, 'percentualEquivalente'),
        valorPassagem: formValueSelector('formularioCadastrarConfiguracaoConsumoPontos')(state, 'valorPassagem'),
    };
}

export default withRouter(connect(mapStateToProps, {
    buscarAdesaoPontoPorEmpresa,
    limparConfiguracaoPontoEmpresa,
    cadastrarConfiguracaoConsumoPontos,
    cadastrarConfiguracaoPonto,
    changeFieldValue,
})(reduxForm({
    form: 'formularioCadastrarConfiguracaoConsumoPontos',
})(PainelCadastroConfiguracaoConsumoPonto)));
